<template>
    <div class="node-container">
        <Nav :currentActive="'Node'" />

        <div class="node-banner">
            <div class="banner">
                <img src="@/assets/images/node-banner.jpg" />
            </div>
            <div class="banner-desc">
                <div class="banner-desc-text">
                    <div class="title">节点介绍</div>
                    <div class="text">通过内置的标识管理能力向整个接入的区块链网络提供标识基础服务进而提供跨链互通能力。</div>
                </div>
                
            </div>
            <div class="nodeBan-net"></div>
        </div>
        <div class="node-desc-text">
            <div class="title">星火·链网</div>
            <div class="text mt40">
                <p>“星火·链网” 是在工业和信息化部指导及在国家相关专项政策的支持下，由中国信通院牵头，联合北京航空航天大学、北京邮电大学、中国联通集团等多家单位设计建设的区块链服务网络，是国家推动区块链新型基础设施建设的重要战略布局。</p>
                <p>“星火·链网”采用许可公有链构建，通过内置的标识管理能力向整个接入的区块链网络提供标识基础服务进而提供跨链互通能力。其体系架构分为两层——上层是由超级节点构成的主链，用于管理标识、公共数据或未来国家提供的相关法定资产，也包括监管规则的实现；下层是通过骨干节点连接的各类型既有的区块链应用，包括行业或者区域各类型应用，可以从主链获得标识、数据、服务等，通过这样的互通促进区块链应用的规模、效果，也为工业互联网真正打通生产和消费的动力转换提供了手段。</p>
            </div>
            
            <div class="node-desc-img mt60">
                <img src="@/assets/images/node-desc.jpg" class="full-maxWidth" />
            </div>
        </div>
        <div class="node-gp">
            <div class="pic">
                <img src="@/assets/images/node-gp.jpg" class="img-wrap" />
            </div>
            <div class="text">
                <div class="title">“星火·链网”骨干节点（珠海横琴）</div>
                <div class="tip mt14">——横琴粤澳链</div>
                <div class=" mt30">
                    <p>横琴粤澳链基于“星火·链网”的建设要求，面向粤港澳各行业提供稳定的区块链和标识解析等服务，通过对人、机、物的全面互联，构建起全要素、全产业链、全价值链全面连接的新型生产制造和服务体系，实现对湾区产业的统一服务，促进湾区数据流、资源流、资金流、技术流、人才流汇聚，进一步增强澳门监造、澳门监制、澳门设计在国际数字贸易中的影响力，助推粤澳地区链网协同高质量发展。</p>
                </div>
            </div>
        </div>
        <div class="node-pos">
            <div class="contain">
                <div class="com-tit">节点定位</div>
            </div>
            <div class="post-list">
                <div class="post-item">
                    <div class="text">
                        <p>粤港澳大湾区</p>
                        <p>第一个节点</p>
                    </div>
                </div>
                <div class="post-item">
                    <div class="text">
                        <p>华南地区第一个面向</p>
                        <p>海外的骨干节点</p>
                    </div>
                    
                </div>
                <div class="post-item">
                    <div class="text">
                        <p>第一个由第三方公司</p>
                        <p>承接运营的骨干节点</p>
                    </div>
                    
                </div>
            </div>
        </div>

        <Footer />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import Nav from '../../components/NavTop.vue';
  import Footer from '../../components/Footer.vue';
  
  const startAnimate = ref(false)

  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .node-container {
    padding-top: 84px;
 }

 .node-banner {
    position: relative;
 }
 .node-banner .banner {
    width: 100%;
 }
 .node-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .node-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .node-banner .banner-desc .title {
    font-size: 30px;
 }
 .node-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .node-desc-text {
    padding: 30px 0;
 }
 .node-desc-text .title {
    font-size: 28px;
    margin: auto;
    text-align: center;
 }
 .node-desc-text .text {
    font-size: 28px;
    width: 80%;
    max-width: 1040px;
    margin: auto;
    text-align: left;
    padding:  0 80px;
 }
 .node-desc-text .node-desc-img {
    width: 1200px;
    margin: auto;
 }
 .node-gp {
    display: flex;
 }
 .node-gp .pic {
    width: 64%;
    position: relative;
    padding-top: 30.669%;
 }
 .img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.node-gp .text {
    width: calc(36% - 188px);
    color: #fff;
    padding: 50px 124px 50px 64px;
    position: relative;
    background: #285198;
    display: flex;
    flex-direction: column;
    justify-content: center;
    z-index: 2;
}
.node-gp .text .title {
    font-size: 28px;
}

.node-gp .text .tip {
    font-size: 18px;
}

.node-pos {
    background: url(../../assets/images/node-pos-bg.jpg) no-repeat center / contain;
    padding: 90px 0;
}
.contain {
    margin: 0 auto;
    width: 1200px;
}
.com-tit {
    color: #333333;
    font-weight: 500;
    line-height: 1.1;
    font-size: 28px;
    text-align: center;
}

.post-list {
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 1200px;
}
.post-list .post-item {
    background: #f7faff;
    height: 252px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 32.5%;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
}
.post-list .post-item:before {
    content: '';
    background: url(../../assets/images/pos-list.png) no-repeat center / 100%;
    width: 298px;
    height: 250px;
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2;
    opacity: 0;
    visibility: hidden;
    transform: translateX(-50%) scale(0);
    transform-origin: center;
    transition: all .6s ease .2s;
}
.post-list .post-item:hover:before {
    visibility: visible;
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
}
.post-list .post-item:after {
    content: '';
    width: 550px;
    height: 550px;
    background: #285198;
    left: 50%;
    top: 50%;
    margin: auto;
    position: absolute;
    visibility: hidden;
    transition: all .4s ease;
    opacity: 0;
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0);
}
.post-list .post-item:hover:after {
    visibility: visible;
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
}

.post-list .post-item .text {
    text-align: center;
    font-weight: 500;
    color: #444444;
    font-size: 18px;
    line-height: 20px;
    padding-bottom: 16px;
    position: relative;
    transition: color .4s ease;
    z-index: 1;
}
.post-list .post-item .text p {
    padding: 0;
    margin: 0;
    font-size: 18px;
    line-height: 24px;
}
.post-list .post-item .text:after {
    content: '';
    width: 28px;
    height: 2px;
    background: #285198;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    transition: background-color .4s ease;
}

.post-list .post-item:hover .text {
    color: #FFFFFF;
}
.post-list .post-item:hover .text:after {
    background: #FFFFFF;
}

.nodeBan-net {
    height: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    width: 540px;
    right: 94px;
}
.nodeBan-net::before {
    content: "";
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    background: url(../../assets/images/BannerNet.png) no-repeat center / auto 100%;
    opacity: 0.5;
}
.nodeBan-net::after {
    content: "";
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(28, 189, 224, 1), rgba(0, 0, 0, 0));
    box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.5);
    top: 22%;
    left: -18%;
    filter: blur(40px);
    mix-blend-mode: color-dodge;
    animation: nodeBanNetRun 8s linear infinite;
    opacity: 0;
}

@keyframes nodeBanNetRun {
    0% {
        top: 22%;
        left: -18%;
        opacity: 0;
    }

    4% {
        top: 22%;
        left: -18%;
        opacity: 1;
    }
    20% {
        top: 22%;
        left: 16%;
        opacity: 1;
    }
    30% {
        top: 42%;
        left: -4%;
        opacity: 1;
    }
    40% {
        top: 54%;
        left: 16%;
        opacity: 1;
    }
    50% {
        top: 42%;
        left: 36%;
        opacity: 1;
    }
    60% {
        top: 8%;
        left: 36%;
        opacity: 1;
    }
    70% {
        top: 22%;
        left: 52%;
        opacity: 1;
    }
    80% {
        top: 8%;
        left: 70%;
        opacity: 1;
    }
    90% {
        top: 28%;
        left: 90%;
        opacity: 1;
    }
    100% {
        top: 28%;
        left: 90%;
        opacity: 0;
    }
}
  
  </style>